import { memo, Suspense } from 'react';
import { Layout } from 'antd';

const BlankLayout = ({ children, Top }) => {
  return (
    <Layout
      className={`blank_layout_wrapper ${
        Top ? 'padding_top_30' : 'remove_padding'
      }`}
    >
      <Suspense fallback={null}>{children}</Suspense>
    </Layout>
  );
};

export default memo(BlankLayout);
